<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="day_master_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat>
            <v-toolbar-title>Select Employee Name</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"> </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Day</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="day_super_master_list_day"
                            v-model="addedItem.day_super_master_list_day" label="Select Day"
                            :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.day" persistent-hint :disabled="editedIndex != -1" :hint="
                              editedIndex == -1
                                ? 'For example ::Monday, Tuesday.. '
                                : 'noneditable'
                            " label="Day" :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-text-field :items="displayname" v-model="addedItem.displayname"
                            label="Select Display Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.displayname" persistent-hint label="Display Name"
                            :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
    //   { text: "Day", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    day_super_master_list_day: "",
    daysequence_super_master: "",
    overlay: false,
    errorMsg: {
      day: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    day_super_master_list: null,
    displayname: "",
    headers: [
      {
        text: "Day",
        align: "left",
        sortable: false,
        value: "day",
      },
      {
        text: "Day Sequence",
        align: "left",
        sortable: false,
        value: "daysequence",
      },
      {
        text: "Display Name",
        align: "left",
        sortable: false,
        value: "displayname",
      },

      { text: "Actions", value: "action", sortable: false },
    ],
    day_master_list: [],
    editedIndex: -1,
    addedItem: {
      day_super_master_list_day: "",
      daysequence: "",
      displayname: "",
    },
    editedItem: {
      id: "",
      day: "",
      daysequence: "",
      displayname: "",
    },
    defaultItem: {
      id: "",
      day: "",
      daysequence: "",
      displayname: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Day" : "Edit Day";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    //   initialize () {

    //   },

    editItem(item) {
      this.editedIndex = this.day_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/day")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.day_master_list = res.data.day_master_list;
              this.day_super_master_list_day =
                res.data.day_super_master_list_day;
              this.daysequence = res.data.daysequence_super_master;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editDay", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                Object.assign(
                  this.day_master_list[this.editedIndex],
                  this.editedItem
                );
              }
              this.showSnackbar("#4caf50", "Day Updated Successfully..."); // show snackbar on success
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //this.day_master_list.push(this.editedItem)
        axios
          .post("/AdmissionMaster/saveDay", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.day_master_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "Day Added Successfully!!!"); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              //window.alert(res.data.status.code)
              //alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Day Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()

    isValidated() {
      if (this.editedItem.day) {
        return true;
      } else {
        if (!this.editedItem.day) {
          this.errorMsg.day = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>